import { TermsAndConditionsWrapper } from "./TermsAndConditionsWrapper";

export default TermsAndConditionsWrapper;